import {typeFromValidation} from '../../helpers/typescript/typeHelpers';

/** All in-product announcement identifiers we've ever used, to ensure global uniqueness. */
export const enum AnnouncementIdsEnum {
  INTERNAL_AI_ANSWERS = 'internalAiAnswers',
  RULE_TESTER_AT_CREATION = 'ruleTesterAtCreation',
  RULE_TESTER_AT_EDITION = 'ruleTesterAtEdition',
  RULE_LIST_RESOLUTION_TIME_SLA = 'ruleListResolutionTimeSla',
  AI_ASSIST = 'aiAssist',
  AI_ASSIST_EXTERNAL_KNOWLEDGE_SOURCE = 'aiAssistExternalKnowledgeSource',
  AI_AUTOPILOT = 'aiAutopilot',
  AI_TERMS = 'aiTerms',
  RINGCENTRAL_RELEASE = 'ringCentralRelease',
  INBOX_REDESIGN = 'inboxRedesign',
  SUPPORT_AT_SCALE = 'supportAtScale',
  MULTI_REQUEST_CONNECTORS = 'multiRequestConnectors',
  WORKFORCE_MANAGEMENT = 'workforceManagement',
  SLACK_CHANNEL_USER_AUTH_ANNOUNCEMENT = 'slackChannelUserAuthAnnouncement',
  SLACK_RELEASE = 'slackRelease',
  SLACK_INBOXES_TIP = 'slackInboxesTip',
  SLACK_MENTIONS = 'slackMentions',
  FLOWCHART_RULE = 'flowchartRule',
  RULE_FLOWCHART_CTA_TIP = 'ruleFlowchartCtaTip',
  INBOX_REDESIGN_REMINDER_1 = 'inboxRedesignReminder1',
  INBOX_REDESIGN_REMINDER_2 = 'inboxRedesignReminder2',
  INBOX_REDESIGN_REMINDER_3 = 'inboxRedesignReminder3',
  INBOX_REDESIGN_REMINDER_4 = 'inboxRedesignReminder4',
  INBOX_REDESIGN_REMINDER_5 = 'inboxRedesignReminder5',
  INBOX_IMPROVEMENTS_AUTO_ENABLE = 'inboxImprovementsAutoEnable',
  INBOX_IMPROVEMENTS_FORCE_ENABLE = 'inboxImprovementsForceEnable',
  INBOX_IMPROVEMENTS_FORCE_ENABLE_RETRY = 'inboxImprovementsForceEnableRetry',
  FRONT_UNWRAPPED = 'frontUnwrapped',
  USER_SURVEY_KEEPING_IN_LOOP = 'userSurveyKeepingInLoop',
  APPLICATION_KNOWLEDGE_SOURCE_TIP_NOTION = 'applicationKnowledgeSourceTipNotion',
  APPLICATION_KNOWLEDGE_SOURCE_TIP_GURU_CONFLUENCE = 'applicationKnowledgeSourceTipGuruConfluence',
  NEW_PRE_BUILT_CONNECTORS_TIP = 'newPreBuiltConnectorsTip',
  CREATE_TASK_RULE_TIP = 'createTaskRuleTip',
  APP_REQUEST_BRANCHING_TIP = 'appRequestBranchingTip',
  ASK_COPILOT = 'askCopilot',
  SF_ASANA_PREBUILT_CONNECTORS_RULE_TEMPLATES = 'sfAsanaPrebuiltConnectorsRuleTemplates',
  SF_ASANA_PREBUILT_CONNECTORS_MACRO_TEMPLATES = 'sfAsanaPrebuiltConnectorsMacroTemplates',
  AUTOPILOT_RESOLVE_PART_OF_AUTOPILOT = 'autopilotResolvePartOfAutopilot',
  AUTOPILOT_RESOLVE_BUILD = 'autopilotResolveBuild',
  AUTOPILOT_RESOLVE_PLAYBOOKS_TIP = 'autopilotResolvePlaybooksTip',
  AUTOPILOT_RESOLVE_SOURCES_TIP = 'autopilotResolveSourcesTip',
}

export type UserSurveyAnnouncementId = `userSurvey-${string}`;

export const RUserSurveyAnnouncementId = typeFromValidation(
  'UserSurveyAnnouncementId',
  (value): value is UserSurveyAnnouncementId => typeof value === 'string' && value.startsWith('userSurvey-'),
);

export type AnnouncementId = AnnouncementIdsEnum | UserSurveyAnnouncementId;
